import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    IconButton,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Tooltip,
} from "@mui/material";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EditNoteIcon from '@mui/icons-material/EditNote';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import SearchBar from "../../components/SearchBar";

const PendingApprovals = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    // Modal state for Request Edits
    const [openEditRequest, setOpenEditRequest] = useState(false);
    const [selectedBlog, setSelectedBlog] = useState<any>(null);
    const [editReason, setEditReason] = useState("");

    // Dummy blog data
    const blogsData = [
        {
            id: 1,
            thumbnail: "/static/images/placeholder.png",
            userimage: "/static/images/user_placeholder.png",
            username: "Alice Crafts",
            useremail: "alice@handmadelabs.com",
            title: "How to Build a Web App",
            type: "Article",
            score: 85,
            time: "10 min read",
            tags: ["Web Development", "React"],
            status: "Pending"
        },
        {
            id: 2,
            thumbnail: "/static/images/placeholder.png",
            username: "Sarah Potter",
            useremail: "sarah@claynco.com",
            userimage: "/static/images/user_placeholder.png",
            title: "Understanding CSS Grid",
            type: "Guide",
            score: 92,
            time: "7 min read",
            tags: ["CSS", "Design"],
            status: "Pending"
        },
        {
            id: 3,
            thumbnail: "/static/images/placeholder.png",
            username: "John Maker",
            useremail: "john@woodworks.com",
            userimage: "/static/images/user_placeholder.png",
            title: "Introduction to Python",
            type: "Tutorial",
            score: 78,
            time: "12 min read",
            tags: ["Python", "Programming"],
            status: "Pending"
        },
    ];

    const handleOpenEditRequest = (blog: any) => {
        setSelectedBlog(blog);
        setOpenEditRequest(true);
    };

    const handleCloseEditRequest = () => {
        setOpenEditRequest(false);
        setEditReason("");
    };

    const handleSendEditRequest = () => {
        console.log(`Sending edit request for ${selectedBlog?.title} with reason: ${editReason}`);
        handleCloseEditRequest();
    };

    return (
        <div className="pending_approvals_page">
            <div className="main_title">
                <h1>Vendor Journals Pipeline</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - <button onClick={() => navigate("/blogs")}>Journals</button> - Pending Approvals
                </p>
            </div>

            <div className="stats_boxes gap_m">
                <div className="cards">
                    <div className="data_top">
                        <h2>12<p>Pending <br /> <small>Awaiting Review</small></p></h2>
                        <figure className="warning">
                            <AssignmentOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </div>
                <div className="cards">
                    <div className="data_top">
                        <h2>8<p>Requesting <br /> <small>Edits in progress</small></p></h2>
                        <figure className="warning">
                            <EditNoteIcon fontSize="large" />
                        </figure>
                    </div>
                </div>
                <div className="cards">
                    <div className="data_top">
                        <h2>45<p>Approved <br /> <small>This month</small></p></h2>
                        <figure className="warning">
                            <CheckCircleOutlineIcon fontSize="large" />
                        </figure>
                    </div>
                </div>
            </div>

            <div className="table_flex mt_20">
                <div className="lt">
                    <div className="cards">
                        <div className="table_header">
                            <Box className="left_s">
                                <SearchBar
                                    searchTerm={searchTerm}
                                    setDebouncedSearchTerm={setSearchTerm}
                                    placeholder="Search vendor name or post title..."
                                />
                            </Box>
                        </div>

                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Sr. No.</TableCell>
                                        <TableCell>Vendor Details</TableCell>
                                        <TableCell>Thumbnail</TableCell>
                                        <TableCell>Submission Title</TableCell>
                                        <TableCell>AI Evaluation</TableCell>
                                        <TableCell>Status / Type</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {blogsData.map((blog, index) => (
                                        <TableRow key={blog.id} hover>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>
                                                <div className="user_block no_radius">
                                                    <figure>
                                                        <img src={blog.userimage} alt={blog.username} />
                                                    </figure>
                                                    <p>
                                                        <b>{blog.username}</b>
                                                        {blog.useremail}
                                                    </p>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <figure style={{ width: '40px', height: '40px', borderRadius: '4px', overflow: 'hidden' }}>
                                                    <img src={blog.thumbnail} alt={blog.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                </figure>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                    <span style={{ fontWeight: 600, fontSize: '14px' }}>{blog.title}</span>
                                                    <span style={{ fontSize: '11px', color: '#6b7280' }}>{blog.time} • {blog.tags.join(", ")}</span>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <span style={{
                                                        background: blog.score > 80 ? '#ecfdf5' : '#fffbeb',
                                                        color: blog.score > 80 ? '#059669' : '#d97706',
                                                        padding: '2px 8px',
                                                        borderRadius: '12px',
                                                        fontWeight: 600,
                                                        fontSize: '12px'
                                                    }}>
                                                        {blog.score}%
                                                    </span>
                                                    <Tooltip title="AI Quality Score">
                                                        <AutoAwesomeIcon sx={{ fontSize: 14, color: '#d97706' }} />
                                                    </Tooltip>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                                    <span style={{ color: '#d97706', fontSize: '12px', fontWeight: 500 }}>{blog.status}</span>
                                                    <span style={{ color: '#6b7280', fontSize: '11px' }}>{blog.type}</span>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="table_actions v2">
                                                    <Box>
                                                        <Tooltip title="Preview Content">
                                                            <IconButton onClick={() => navigate("/vendor-blogs/view")}>
                                                                <VisibilityOutlinedIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                       
                                                        <Tooltip title="Approve Submission">
                                                            <IconButton sx={{ color: '#059669' }}>
                                                                <CheckCircleOutlineIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Request Edits">
                                                            <IconButton onClick={() => handleOpenEditRequest(blog)} sx={{ color: '#d97706' }}>
                                                                <EditNoteIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Reject Submission"  onClick={() => handleOpenEditRequest(blog)} sx={{ color: '#d97706' }}>
                                                            <IconButton sx={{ color: '#dc2626' }}>
                                                                <HighlightOffIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>

                <div className="rt">
                    <div className="ai_content_ideas_wrapper">
                        <div className="content_idea_card">
                            <div className="card_image">
                                <img src="/static/images/placeholder.png" alt="Decor" />
                            </div>
                            <h3>Pipeline Insights</h3>
                            <div className="idea_content">
                                <LightbulbOutlinedIcon className="icon" style={{ fontSize: 16, color: '#d97706' }} />
                                <div className="text">
                                    <h4>Most active category: Web Design</h4>
                                    <p>Vendors are submitting 20% more content in design categories this week.</p>
                                </div>
                            </div>
                            <button className="generate_btn">
                                <AutoAwesomeIcon style={{ fontSize: 14 }} /> Review Trends
                            </button>
                        </div>
                    </div>

                    <div className="ai_panel">
                        <h4>AI Approval Assistance</h4>
                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p><b>2 Posts</b> have similar content to existing journals</p>
                        </div>
                        <div className="ai_alert success">
                            <span className="icon">✨</span>
                            <p><b>5 Posts</b> are highly optimized for SEO</p>
                        </div>
                        <small className="ai_update">Next analysis in: <b>2 Hours</b></small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>Plagiarism Check</h5>
                                    <p>Post #182 passed with 98% uniqueness</p>
                                </div>
                            </div>
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>Engagement Prediction</h5>
                                    <p>CSS Grid guide likely to trend</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Request Edits Dialog */}
            <Dialog open={openEditRequest} onClose={handleCloseEditRequest} fullWidth maxWidth="sm">
                <DialogTitle sx={{ fontWeight: 600 }}>Request Edits from Vendor</DialogTitle>
                <DialogContent className="form">
                    <p style={{ fontSize: '14px', color: '#666', marginBottom: '15px' }}>
                        Post: <b>{selectedBlog?.title}</b>
                    </p>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="reason"
                        label="Reason for request / Required changes"
                        type="text"
                        fullWidth
                        multiline
                        rows={4}
                        variant="outlined"
                        value={editReason}
                        onChange={(e) => setEditReason(e.target.value)}
                        placeholder="Please explain what the vendor needs to fix (e.g., higher quality images, clarified intro)..."
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button onClick={handleCloseEditRequest} className="btn_outline">Cancel</Button>
                    <Button onClick={handleSendEditRequest} className="btn btn_primary" disabled={!editReason}>
                        Send Request
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default PendingApprovals;

